<template>
  <el-row>
    <el-col>
      <el-card
        shadow="never"
        class="mb-3"
      >
        <el-form label-position="top">
          <el-row :gutter="15">
            <el-col :span="6">
              <el-form-item label="Carrier">
                <el-autocomplete
                  v-model="carrierInput.name"
                  :fetch-suggestions="querySearchCarrier"
                  placeholder="Enter name of Carrier"
                  :trigger-on-focus="false"
                  class="w-100"
                  placement="bottom"
                  value-key="name"
                  :debounce="500"
                  clearable
                  @select="handleSelectCarrier"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="Service">
                <el-select
                  v-model="service.name"
                  placeholder="Select a Carrier Service"
                  value-key="id"
                  filterable
                  class="w-100"
                  :loading="isLoadingCarrierServices"
                  @change="handleSelectService"
                >
                  <el-option
                    v-for="(cs, index) in carrierServices"
                    :key="index"
                    :label="`${$_.get(cs, 'name', '-')}`"
                    :value="cs"
                  >
                    <span style="float: left">{{ $_.get(cs, 'name', '-') }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="From">
                <el-autocomplete
                  v-model="location_from.suburb"
                  :fetch-suggestions="suburbQuerySearch"
                  placeholder="Enter name of suburb"
                  :trigger-on-focus="false"
                  class="w-100"
                  placement="bottom"
                  :debounce="500"
                  clearable
                  @select="handleSelectSuburbFrom"
                >
                  <template v-slot="{ item }">
                    {{ formatSuburbByLocation(item) }}
                  </template>
                </el-autocomplete>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="To">
                <el-autocomplete
                  v-model="location_to.suburb"
                  :fetch-suggestions="suburbQuerySearch"
                  placeholder="Enter name of suburb"
                  :trigger-on-focus="false"
                  class="w-100"
                  placement="bottom"
                  :debounce="500"
                  clearable
                  @select="handleSelectSuburbTo"
                >
                  <template v-slot="{ item }">
                    {{ formatSuburbByLocation(item) }}
                  </template>
                </el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <el-card
        shadow="never"
        :gutter="15"
      >
        <el-table
          v-loading="isLoading"
          :data="etds"
          stripe
          size="mini"
          style="overflow-x: scroll;"
        >
          <el-table-column
            label="Carrier"
            :formatter="row => $_.get(row, 'carrier.name') || '-'"
          />
          <el-table-column
            label="Service"
            :formatter="row => $_.get(row, 'carrier_service.name') || '-'"
          />
          <el-table-column
            label="Location From"
            :formatter="row => formatSuburbByLocation($_.get(row, 'location_from')) || '-'"
          />
          <el-table-column
            label="Location To"
            :formatter="row => formatSuburbByLocation($_.get(row, 'location_to')) || '-'"
          />
          <el-table-column
            label="Zone From"
            :formatter="row => $_.get(row, 'zone_from.desc') || '-'"
          />
          <el-table-column
            label="Zone To"
            :formatter="row => $_.get(row, 'zone_to.desc') || '-'"
          />`
          <el-table-column
            label="Travel Time"
            :formatter="row => $_.get(row, 'travel_days') || '-'"
          />
        </el-table>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data () {
    return {
      title: 'Delivery Times',
      isLoading: false,
      isLoadingCarrierServices: false,
      carrierInput: {},
      service: {},
      location_from: {},
      location_to: {},
      carrierServices: [],
      etds: [],
      breadcrumb: {
        name: 'Delivery Times',
        route: { name: 'freight-deliverytimes' }
      }
    }
  },
  methods: {
    carrierQuerySearch (queryString) {
      this.$sdk.carrier.list(builder => {
        builder.order = 'name:asc'
        builder.filters = { 'name': queryString }
      }).then(res => {
        this.carriers = res
      })
        .finally(() => {
          this.isLoading = false
        })
    },
    suburbQuerySearch (queryString, cb) {
      this.$sdk.dictionary_location.list(builder => {
        builder.page = 1
        builder.limit = 50
        builder.filters = { dictionary_location_find: [queryString] }
        builder.order = 'suburb:asc'
      }).then(res => {
        cb(res)
      })
    },
    handleSelectSuburbFrom (item) {
      this.location_from = item
    },
    handleSelectSuburbTo (item) {
      this.location_to = item
      this.timeQuerySearch()
    },
    formatSuburbByLocation (location) {
      if (location) {
        return `${location.suburb}, ${location.state}, ${location.postcode}`
      } else return ''
    },
    querySearchCarrier (queryString, cb) {
      this.$sdk.carrier.list(builder => {
        builder.filters = { 'carrier_name': queryString }
      }).then(res => {
        cb(res)
      })
    },
    handleSelectCarrier (item) {
      this.carrier = item
      this.loadCarrierServices()
    },
    loadCarrierServices () {
      if (this.carrier instanceof this.$sdk.carrier) {
        this.isLoadingCarrierServices = true

        this
          .$sdk
          .carrier_service
          .list(builder => {
            builder.context = this.carrier
            builder.filters = { carrier_service_type: 1 }
            builder.page = 1
            builder.limit = 500
            builder.order = 'name:asc'
          })
          .then(res => { this.carrierServices = res })
          .finally(() => { this.isLoadingCarrierServices = false })
      }
    },
    handleSelectService (item) {
      this.service = item
    },
    timeQuerySearch (cb) {
      this.isLoading = true
      this.$sdk.etd.list(builder => {
        builder.page = 1
        builder.limit = 50
        builder.filters = {
          carrier: this.carrier.id,
          carrier_service: this.service.id,
          location_from: this.location_from.id,
          location_to: this.location_to.id
        }
      }).then(res => {
        this.etds = res
      }).finally(() => { this.isLoading = false })
    }
  }
}
</script>
